import { useEffect, useRef } from "react";

declare global {
  interface Window {
    kofiwidget2?: {
      init: (text: string, color: string, id: string) => void;
      draw: () => void;
      getHTML: () => string;
    };
  }
}

export default function KofiButton() {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const renderWidget = () => {
      if (!window.kofiwidget2 || !containerRef.current) return;
      window.kofiwidget2.init("Support me ", "#FF69B4", "M4M21Y2DQ2");
      containerRef.current.innerHTML = window.kofiwidget2.getHTML();
    };

    if (window.kofiwidget2) {
      renderWidget();
      return;
    }

    const existing = document.querySelector<HTMLScriptElement>(
      'script[src="https://storage.ko-fi.com/cdn/widget/Widget_2.js"]'
    );
    if (existing) {
      existing.addEventListener("load", renderWidget);
      return () => existing.removeEventListener("load", renderWidget);
    }

    const script = document.createElement("script");
    script.src = "https://storage.ko-fi.com/cdn/widget/Widget_2.js";
    script.async = true;
    script.onload = renderWidget;
    document.body.appendChild(script);
  }, []);

  return <div ref={containerRef} className="flex items-center" aria-label="Support on Ko-fi" />;
}
